class PrivacyDeclarationController {
  constructor() {
    this.name = 'privacyDeclaration';
  }
}

export default PrivacyDeclarationController;



// WEBPACK FOOTER //
// ./client/app/common/privacyDeclaration/privacyDeclaration.controller.js